import React from 'react';

function Coins() {
  return <div></div>;
}

export default Coins;
